import {baseUrl} from '@/api/base-url'
import {replaceApi} from '@/helpers/utils'

export const limit = 5
export const nameToken = 'ks_token'
export const currentSchoolId = 'ks_school_id'
export const currentSchoolType = 'ks_school_type'
export const limitFile = 10
export const maskPhone = '+380 ## ### ####'

export const financeDefault = {
  kpkv: null,
  numberDays: '0',
  rozporyadnykKoshtiv: null,
  status: 'План',
  participants: '0',
  trainers: '0',
  judges: '0',
  accompanying: '0',
  food: '0',
  residence: '0',
  driveway: '0',
  daily: '0',
  prizes: '0',
  rent: '0',
  organization: '0',
}

export const support = {
  tel: '+380443668072',
  email: 'support.sport@kyivcity.gov.ua',
  // telegramGroup: 'sports_kyivcity',
}

export const linkPersonalAgreement =
  replaceApi(baseUrl) + '/personal-data-agreement'
